import React from "react";
import "../styles/About.css";
import profileImage from "../assets/profile.jpg";
import profileImageDark from "../assets/profiledark.jpg";
//import JavaLogo from "../assets/java-logo.png";
import MongoLogo from "../assets/mongo-db.png";
import NodeLogo from "../assets/nodeJS-logo.png";

const About = ({ isDarkMode }) => {
    return (
        <div className="about-container">
            <h1 className="about-title">About Me</h1>
            <div className="about-content">
                {/* Left Section: Photo Card */}
                <div className="about-photo-card">
                    <img
                        src={isDarkMode ? profileImageDark : profileImage} // Conditional rendering for profile image
                        className="about-photo"
                        alt="Profile"
                    />
                    <div className="tech-icons">
                        <img
                            src={NodeLogo}
                            alt="NodeJS"
                            className="tech-icon"
                        />
                        <img
                            src="https://upload.wikimedia.org/wikipedia/commons/a/a7/React-icon.svg"
                            alt="React"
                            className="tech-icon"
                        />
                        <img
                            src={MongoLogo}
                            alt="MongoDB"
                            className="tech-icon"
                        />
                    </div>
                </div>

                {/* Right Section: Browser Mockup */}
                <div className="browser-mockup">
                    <div className="browser-header">
                        <span className="browser-dot red"></span>
                        <span className="browser-dot yellow"></span>
                        <span className="browser-dot green"></span>
                    </div>
                    <div className="browser-content">
                        <h2>Hi :)</h2>
                        <p>
                            👋 I'm Abhishek Tiwari, a Full-Stack Developer 💻 skilled in React ⚛️,
                            Node.js 🌐, and Spring Boot 🚀. I have expertise in cloud technologies ☁️ (AWS, GCP)
                            and databases like PostgreSQL 🐘 and MongoDB 🍃. I love creating scalable
                            solutions 📈 and building intuitive applications ✨ to solve complex problems.
                        </p>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default About;
